import React, { useEffect, useState } from 'react';
import Topbar from '../components/Topbar';
import Leftbar from '../components/Leftbar';
import { Link } from 'react-router-dom';
import { exportUser, getUsers, displaySuccess, displayError, getReportedPhysio, reportAction, walletPhysioList, getPredefinedMessages, getProviderWallets, WalletTransactions } from '../Utils/utils';
import { toggleLoader } from '../actions/loader';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import config from '../config/config';
import axios from 'axios';
import Select from 'react-select';

const WalletTransaction = (props) => {
  const [users, setUsers] = useState([]);
  const [limit, setLimit] = useState(10);
  const [skip, setSkip] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [total, setTotal] = useState('');
  const [selOptions, setSelOptions] = useState([])
  const [selected, setSelected] = useState([])
  const [selectUserId, setSelectUserId] = useState([]);


  const getWallets = async () => {
    props.toggleLoader(true);
    var res = await WalletTransactions(props.match.params.id, limit, skip)
    setUsers(res.data)
    props.toggleLoader(false);
  }

  useEffect(() => {
    getWallets()
  }, [skip])

  const handlePageClick = async (e) => {
    props.toggleLoader(true);
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    const selectedPage = e.selected;
    setSkip(selectedPage * limit)
    // getList(search)

    props.toggleLoader(false);
  };

  const fromTime = (time) => {
    var tym = time.split(' ')
    const from = moment(tym[1], 'h:mm a').format('hh:mm')
    return `${from}${parseInt(tym[1].split(':')[0]) >= 12 ? ' PM' : ' AM'}`
  }
  return (
    <>
      <body class="g-sidenav-show  bg-gray-100">
        <div id="wrapper">
          <Leftbar />
          <main className="main-content border-radius-lg">
            <Topbar />

            <div className="header bg-primary pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4">
                        <ol className="breadcrumb breadcrumb-links breadcrumb-dark">
                          <li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
                          <li className="breadcrumb-item"><Link to="/provider-wallet">Service Provider Wallet</Link></li>
                          <li className="breadcrumb-item"><a href="#">Wallet Transactions</a></li>
                        </ol>
                      </nav>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card">
                    <div className="card-header border-0">
                      <div className="row">
                        <div className="col-6">
                          <h3 className="mb-0">Wallet Transactions</h3>
                        </div>

                      </div>
                      <div className='row mt-2'>

                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            <th>booking number</th>
                            <th>Session Date</th>
                            <th>Session Time</th>
                            <th>Description</th>
                            <th>Amount</th>
                            <th>status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {users?.length > 0 ? users?.map((user) => (
                            <tr>

                              <td className="table-user">
                                {user.booking ?
                                  <b className='name2'>
                                    {user.booking?.booking_number}
                                  </b>
                                  :
                                  <div className='name2'>N/A</div>
                                }
                              </td>
                              <td className="table-user">
                                <b className='name2'>{moment(user.session?.createdAt).format('DD/MM/YYYY')}</b>
                              </td>
                              <td className="table-user">
                                {user?.session ?
                                  <b className='name2'>{fromTime(user?.session?.fromTime)} to {fromTime(user?.session?.toTime)}</b>
                                  :
                                  <div className='name2'>N/A</div>
                                }
                              </td>
                              <td className="table-user">
                                <b className='name2'>{user.description}</b>
                              </td>
                              <td className="table-user">
                                <b className='name2'>{user?.type == 'debit' ? '-' : '+'}{user.amount}</b>
                              </td>
                              <td className="table-user">
                                <b className='name2'>{user.status}</b>
                              </td>

                              {/* <td>
                                <button className="btn btn-primary pull-right" style={{ width: '140px' }}
                                // onClick={() => actionReport(user?._id)}
                                >View Transactions</button>
                              </td> */}

                            </tr>
                          ))
                            :
                            < td colSpan={7}>

                              <div style={{ textAlign: 'center' }}>
                                No Wallet
                              </div>
                            </td>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              {users.length > 0 &&
                <Row>
                  {/* <Col xs={4}>
                    <div className='mb-1'>
                      <FormattedMessage id="Showing" /> {users?.length} <FormattedMessage id="accountants from page" /> {current_page} <FormattedMessage id="of" /> {pageCount}
                    </div>
                  </Col> */}
                  <Col xs={12}>
                    <div className='paginate-css'>
                      <ReactPaginate
                        previousLabel="<"
                        nextLabel=">"
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={0}
                        pageRangeDisplayed={3}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        // subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                      />
                    </div>
                  </Col>
                </Row>}

              {/* {users && users.length > 0 &&
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                  {skip != 0 &&
                    <button className="btn btn-primary mr-4" onClick={(e) => {
                      setSkip(skip - limit)
                    }}> Prev </button>
                  }
                  {users.length != 0 && users?.length == limit &&
                    <button className="btn btn-primary pull-right" onClick={(e) => {
                      setSkip(skip + limit)
                    }} > Next </button>
                  }
                </div>
              } */}
            </div>

          </main>
        </div >
      </body >
    </>
  )
}
const mapDispatchToProps = {
  toggleLoader
}
const mapStateToProps = (state) => {
  return {
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(WalletTransaction);
